<template>
  <div class="report-page">
    <is-empty size="small" :show="reports.length > 0" message="该实验没有题目~">
      <el-row class="report-main">
        <div class="editor">
          <div class="report-title">
            <img src="~@/assets/imgs/ic_problem.png"> 题目
            <button class="sub-btn" @click="checkReport">提交</button>
          </div>
          <div class="title-info">{{ report.title }}</div>
          <div class="report-title"><img src="~@/assets/imgs/ic_describe.png"> 答案</div>
          <div class="report-info">
            <editor :content="report.answer" @onchange="handleChange" @onblur="onblur" />
          </div>
        </div>
        <div class="answer-card" v-show="showCard">
          <div class="card-title">答题卡</div>
          <div class="card-number" :class="{ 'number-active': index == indexQuestion }" v-for="(re, index) in reports" :key="index" @click="handleClickCard(index)">{{ index + 1 }}</div>
          <div class="card-bottom" @click="showCard = false">
            <i class="el-icon-arrow-up"></i>
          </div>
        </div>
        <div class="small-card" v-show="!showCard" @click="showCard = true">
          <i class="el-icon-arrow-right"></i>
        </div>
      </el-row>
    </is-empty>
  </div>
</template>

<script>
import editor from '@/components/common/editor'
import isEmpty from '@/components/common/is-empty'
import { submitRaceExpUserReport, getRaceExpUserReportDetail } from '@/api/lab/race-exp-report-user'
export default {
  data () {
    return {
      reports: [],
      indexQuestion: 0, // 当前题目索引
      report: {
        title: '',
        answer: '',
      },
      showCard: true,
    }
  },
  props: {
    uid: {
      type: String
    },
    isSave: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  watch: {
    isSave (n) {
      if (n) {
        // 保存
      }
    }
  },
  components: { editor, isEmpty },
  methods: {
    // 获取题目
    getReports () {
      getRaceExpUserReportDetail(this.uid).then(res => {
        let { report, answer } = res
        if (report) {
          let questions = answer || report
          questions = JSON.parse(questions) || []
          questions.map((item, i) => {
            item = {
              answer: '',
              ...item
            }
            questions[i] = item
          })
          this.reports = questions
          this.handleClickCard(0)
        }
      })
    },
    // 切换题目
    handleClickCard (index) {
      if (this.reports[index]) {
        this.indexQuestion = index
        this.report = this.reports[index]
      } else {
        this.indexQuestion = 0
        this.report = {
          title: '',
          answer: ''
        }
      }
    },
    // 提交实验报告
    checkReport () {
      let answer = JSON.stringify(this.reports)
      submitRaceExpUserReport({
        uid: this.uid,
        answer,
        status:1
      }).then(() => {
        this.$message({
          message: '保存成功!',
          type: 'success',
          duration: '2000',
          onClose: () => {
            this.$router.back(-1)
          }
        })
      })
    },
    // 富文本编辑框内容改变时
    handleChange (html) {
      this.setAnswer(html)
    },
    // 富文本编辑框失去焦点时
    onblur (info) {
      this.setAnswer(info)
    },
    // 设置题目答案
    setAnswer (str) {
      let index = this.indexQuestion
      this.report.answer = str
      this.reports[index].answer = str
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.getReports()
    })
  }
}
</script>

<style lang="less" scoped>
@import "~@/assets/css/exp-run-report";
</style>
